import { createContext, useContext } from "react";
import { useTournamentParticipant } from "./use-tournament-participant";

interface ParticipantContextType
  extends ReturnType<typeof useTournamentParticipant> {}

const ParticipantContext = createContext<ParticipantContextType | null>(null);

export const ParticipantProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const participant = useTournamentParticipant();

  const value = participant;

  return (
    <ParticipantContext.Provider value={value}>
      {children}
    </ParticipantContext.Provider>
  );
};

export const useParticipantContext = () => {
  const context = useContext(ParticipantContext);
  if (!context) {
    throw new Error("useContext must be used within a ParticipantProvider");
  }
  return context;
};
